module.exports = __webpack_public_path__ + "static/media/top-logo-hotel.4432df92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/top-logo-hotel.svg
// module id = 387
// module chunks = 0